/**
 * Base context utilities for cards list widget
 */

export interface PageContext {
  region?: string
  city?: string
  venue?: string
  showName?: string
  title?: string
  type?: string
}

export const parsePageContext = (container: HTMLElement | PageContext): PageContext => {
  // If already a PageContext object, return it
  if (typeof container === 'object' && 'region' in container && !('dataset' in container)) {
    return container as PageContext
  }

  // Otherwise, parse from DOM element
  return {
    region: (container as HTMLElement).dataset.region,
    city: (container as HTMLElement).dataset.city,
    venue: (container as HTMLElement).dataset.venue,
    showName: (container as HTMLElement).dataset.showName,
    title: (container as HTMLElement).dataset.title,
    type: (container as HTMLElement).dataset.type,
  }
}
